import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as emailTemplateAction from './../../../../actions/emailTemplateAction';
import EmailTemplates from './EmailTemplates';

const mapStateToProps = state => {
    return {
        emailTemplateState: state.emailTemplateReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getEmailTemplates: (params) => dispatch(emailTemplateAction.getListEmailTemplates(params)),
        deleteEmailTemplate: (emailTemplate, refreshParams) => dispatch(emailTemplateAction.deleteEmailTemplateDetail(emailTemplate, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(EmailTemplates));
